__webpack_require__.p = "https://quinto-frontend.s3.ca-central-1.amazonaws.com/dev/202610131442/";